// extracted by mini-css-extract-plugin
module.exports = {"modifiedTime":"article-module--modifiedTime--2VRZL"};